import type { ScatterplotComponentSpec } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { calendarWidgetDatePatch } from "./_shared";

export const scatterplotControlPanel: ControlPanelHandler<ScatterplotComponentSpec> = (spec, patch) => {
  spec.scatterplot_builder_misc = {
    ...spec.scatterplot_builder_misc,
    ...(patch.applyDate && calendarWidgetDatePatch(patch.date)),
    ...(patch.applySubjects && patch.subjects),
  };
};
